module.exports = __webpack_public_path__ + "img/tratamiento_outline.621782c3.svg";